export const styles = () => ({
  super: {
    padding: "16px 22px",
    height: "93vh",
    overflowY: "scroll"
  },
  header: {
    height: 60,
    background: "white",
    border: '1px solid #dadada',
    padding: "12px 16px",
    fontSize: 24,
    lineHeight: "36px",
    fontFamily: 'Open Sans',
  },
  flexBox: {
    display: 'flex',
    alignItems: "center",
    flexWrap: 'wrap',
  },
  emptyText: {
    textAlign: 'center',
    lineHeight: "45px",
    fontDize: "16px",
    opacity: "0.7"
  },
  emptyContainer: {
    marginTop: "13px",
    border: "1px solid #dadada",
    display: 'flex',
    alignItems: "center",
    justifyContent: "center",
    height: "82vh",
    background: "white"
  },
  imageStyle: {
    width: "50px",
    height: "50px",
    cursor: "pointer"
  },
})

